import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
import { FiChevronUp } from '@react-icons/all-files/fi/FiChevronUp';
import { StyledMenuOption } from '../../styles';
import type { ButtonProps } from '@core/design-system/button';

interface INavbarButtonMenuProps extends ButtonProps {
  isOpen: boolean;
  title: string;
}

export const NavbarButtonMenu = ({
  isOpen,
  handleClick,
  title,
  ...props
}: INavbarButtonMenuProps) => (
  <StyledMenuOption
    size="small"
    endIcon={isOpen ? <FiChevronUp /> : <FiChevronDown />}
    sx={(theme) => ({
      color: isOpen ? theme.palette.secondary.main : `#fff`,
      fontWeight: 600,
    })}
    {...props}
  >
    {title}
  </StyledMenuOption>
);
